(function() {
  vtex.define('shipping/script/component/CountrySelect',['flight/lib/component', 'shipping/script/setup/extensions', 'shipping/script/models/Address', 'shipping/script/mixin/withi18n', 'shipping/script/mixin/withValidation', 'shipping/templates/countrySelect'], function(defineComponent, extensions, Address, withi18n, withValidation, template) {
    var CountrySelect;
    CountrySelect = function() {
      this.defaultAttrs({
        data: {
          hasAvailableAddresses: false,
          country: false,
          deliveryCountries: [],
          showCountrySelect: false
        },
        deliveryCountrySelector: '#ship-country',
        cancelAddressFormSelector: '.cancel-address-form a'
      });
      this.render = function() {
        var _this = this;
        return dust.render(template, this.attr.data, function(err, output) {
          output = $(output).i18n();
          return _this.$node.html(output);
        });
      };
      this.onSelectCountry = function(ev, data) {
        var country;
        country = data.el.value;
        return this.trigger('countrySelected.vtex', [country, true]);
      };
      this.transformCountries = function(countries) {
        var country, newCountries, _i, _len,
          _this = this;
        newCountries = [];
        for (_i = 0, _len = countries.length; _i < _len; _i++) {
          country = countries[_i];
          newCountries.push({
            code: country,
            name: i18n.t('countries.' + country)
          });
        }
        return newCountries.sort(function(a, b) {
          return a.name.localeCompare(b.name);
        });
      };
      this.enable = function(ev, deliveryCountries, address, hasAvailableAddresses, defaultCountry) {
        var _ref, _ref1, _ref2, _ref3;
        if (ev != null) {
          ev.stopPropagation();
        }
        this.attr.data.deliveryCountries = this.transformCountries(deliveryCountries);
        this.attr.data.hasAvailableAddresses = hasAvailableAddresses;
        if (this.attr.data.deliveryCountries.length > 1) {
          this.attr.data.showCountrySelect = true;
        }
        this.attr.data.country = (_ref = (_ref1 = (_ref2 = address != null ? address.country : void 0) != null ? _ref2 : defaultCountry) != null ? _ref1 : (_ref3 = this.attr.data.deliveryCountries) != null ? _ref3[0] : void 0) != null ? _ref : null;
        return this.render();
      };
      this.disable = function(ev) {
        if (ev != null) {
          ev.stopPropagation();
        }
        return this.$node.html('');
      };
      this.cancelAddressForm = function(ev) {
        ev.preventDefault();
        this.disable();
        this.trigger('cancelAddressEdit.vtex');
        return this.trigger('cancelAddressSearch.vtex');
      };
      return this.after('initialize', function() {
        this.on('enable.vtex', this.enable);
        this.on('disable.vtex', this.disable);
        this.on('change', {
          'deliveryCountrySelector': this.onSelectCountry
        });
        this.on('click', {
          'cancelAddressFormSelector': this.cancelAddressForm
        });
        return this.setLocalePath('shipping/script/translation/');
      });
    };
    return defineComponent(CountrySelect, withi18n, withValidation);
  });

}).call(this);

